import { get, includes } from "lodash"
import PropTypes from "prop-types"
import { AttachMoney, Numbers, Percent } from "@mui/icons-material"
import { METRIC_TYPES_SHAPE, METRICS_SHAPE } from "helpers/metrics/shapes"
import { METRICS, METRIC_TYPES } from "helpers/metrics/constants"

export default function UnitIcon({ selectedUnit, metric }) {
  if (!selectedUnit) { return null }
  const id = get(selectedUnit, "id")
  if (includes([METRIC_TYPES.CURRENCY_EXPOSURE, METRIC_TYPES.CURRENCY_PERFORMANCE], id)) {
    return <AttachMoney />
  }

  if (id === METRIC_TYPES.NET_CONTRIBUTION && metric === METRICS.EXPOSURE) {
    return <Numbers />
  }

  return <Percent />
}

UnitIcon.propTypes = {
  selectedUnit: PropTypes.shape({
    id: METRIC_TYPES_SHAPE.isRequired,
  }),
  metric: METRICS_SHAPE.isRequired,
}
